"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var DOMHelper_1 = require("./DOMHelper");
var types_1 = require("./types");
var heightPercentage = 93;
var widthPercentage = 96;
var logLevelToStyle =
  ((_a = {}),
  (_a[types_1.LogLevel.off] = "off"),
  (_a[types_1.LogLevel.trace] = "trace"),
  (_a[types_1.LogLevel.debug] = "debug"),
  (_a[types_1.LogLevel.info] = "info"),
  (_a[types_1.LogLevel.warn] = "warn"),
  (_a[types_1.LogLevel.error] = "error"),
  _a);
var LogOverlay = /** @class */ (function () {
  function LogOverlay() {
    var _this = this;
    this.domTree = DOMHelper_1.DOMHelper.createDivWithParent();
    this.totalHeight = 0;
    this.show = function () {
      var _a, _b, _c;
      var parent =
        (_b = document.getElementById(
          (_a = _LogContext.logConfig.rootElementId) !== null && _a !== void 0 ? _a : ""
        )) !== null && _b !== void 0
          ? _b
          : DOMHelper_1.DOMHelper.getBody();
      _this.domTree =
        (_c = document.getElementById("logOverlay")) !== null && _c !== void 0
          ? _c
          : DOMHelper_1.DOMHelper.createElementWithParent("div", parent, "logOverlay");
      _this.domTree.style.fontSize = _LogContext.logConfig.overlayFontSize + "px";
      _this.domTree.style.lineHeight = _LogContext.logConfig.overlayFontSize - 2 + "px";
      _this.domTree.style.zIndex = "999";
      _this.domTree.style.position = "absolute";
      _this.domTree.style.border = "3px solid white";
      _this.domTree.style.width = widthPercentage + "%";
      _this.domTree.style.height = heightPercentage + "%";
      _this.domTree.style.top = (100 - heightPercentage) / 2 + "%";
      _this.domTree.style.left = (100 - widthPercentage) / 2 + "%";
      _this.domTree.style.backgroundColor = "#444";
      _this.domTree.style.fontFamily = "monospace";
      _this.domTree.style.color = "#FFF";
      _this.domTree.style.textShadow = "black 0 0 1px";
      _this.domTree.style.opacity = "0.8";
      _this.domTree.style.padding = "0";
      _this.domTree.style.overflowY = "hidden";
    };
    this.hide = function () {
      var _a;
      (_a = _this.domTree.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(_this.domTree);
      _this.totalHeight = 0;
    };
    this.domTree.id = "overlay";
    this.domTree.dir = "ltr";
  }
  /**
   * used internally to build message DOM and display it in DOM
   * @param logLevel error/warn/log
   * @param msg the log message
   */
  LogOverlay.prototype.logWithLevel = function (logLevel, msg) {
    if (logLevel == types_1.LogLevel.off) return;
    var htmlElement = DOMHelper_1.DOMHelper.createElementWithParent("div");
    htmlElement.style.wordBreak = "break-all";
    switch (logLevel) {
      case types_1.LogLevel.error:
        htmlElement.style.color = "#F44";
        htmlElement.style.fontWeight = "bold";
        break;
      case types_1.LogLevel.warn:
        htmlElement.style.color = "#FF4";
        break;
      case types_1.LogLevel.info:
        htmlElement.style.color = "#8FF";
        break;
      case types_1.LogLevel.debug:
        htmlElement.style.color = "#8FF";
        htmlElement.style.opacity = "0.75";
        break;
      case types_1.LogLevel.trace:
        htmlElement.style.color = "#8FF";
        htmlElement.style.opacity = "0.5";
        break;
      default:
        break;
    }
    htmlElement.className = logLevelToStyle[logLevel];
    htmlElement.innerHTML =
      '<span style="color: #FFF;font-weight: bold; text-shadow: black 0 0 1px;">' +
      msg.timestamp +
      "</span> " +
      msg.log;
    this.pushHTMLElement(htmlElement);
  };
  /**
   * used internally to push an HTMLElement in Overlay
   * @param element HTMLElement to push in Overlay
   */
  LogOverlay.prototype.pushHTMLElement = function (element) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    (_a = this.domTree) === null || _a === void 0
      ? void 0
      : _a.insertBefore(element, (_b = this.domTree) === null || _b === void 0 ? void 0 : _b.firstElementChild);
    this.totalHeight += element.getBoundingClientRect().height;
    //cleanup if too many elements
    var removedHeight =
      (_e =
        (_d = (_c = this.domTree.lastElementChild) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect()) ===
          null || _d === void 0
          ? void 0
          : _d.height) !== null && _e !== void 0
        ? _e
        : 0;
    while (this.totalHeight - removedHeight >= Math.floor((heightPercentage * window.innerHeight) / 100)) {
      this.totalHeight -= removedHeight;
      this.domTree.lastElementChild &&
        ((_f = this.domTree) === null || _f === void 0 ? void 0 : _f.removeChild(this.domTree.lastElementChild));
      removedHeight =
        (_j =
          (_h =
            (_g = this.domTree.lastElementChild) === null || _g === void 0 ? void 0 : _g.getBoundingClientRect()) ===
            null || _h === void 0
            ? void 0
            : _h.height) !== null && _j !== void 0
          ? _j
          : 0;
    }
  };
  return LogOverlay;
})();
exports.default = new LogOverlay();
//# sourceMappingURL=logOverlay.js.map
